<template>
  <div>
    <AutoLogout />
    <TheHeader />
    <keep-alive>
      <!-- <transition name="fade"> -->
      <router-view></router-view>
      <!-- </transition> -->
    </keep-alive>
    <TheSidebar />
    <TheFooter />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import TheHeader from "./TheHeader";
import TheSidebar from "./TheSidebar";
import TheFooter from "./TheFooter";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheSidebar,
    TheFooter
  },
  computed: {
    ...mapGetters(["user"]),
  }
};
</script>
